import { type VariantProps, cva } from 'class-variance-authority';
import { Icon } from '../../Icon/Icon';
import { IconButton } from '../../IconButton/IconButton';
import { ProgressBar } from '../../ProgressBar/ProgressBar';

const progressTopBar = cva('top-0 w-full', {
  variants: {
    position: {
      scroll: '',
      fixed: 'sticky',
    },
  },
  defaultVariants: {
    position: 'fixed',
  },
});

type ProgressTopBarSharedProps = VariantProps<typeof progressTopBar> & {
  progress: number; // <= 100
  onBackButtonClick?: () => void;
  backButtonDisabled?: boolean;
};

/**
 * * Important usage note! *
 * When in fixed position, the topbar will stay fixed only until its nearest ancestor is off-screen - its
 * parent needs to be styled to stay on-screen for the header to behave correctly.
 */
export const ProgressTopBar = ({
  progress,
  position,
  onBackButtonClick,
  backButtonDisabled = false,
}: ProgressTopBarSharedProps) => {
  return (
    <div className={progressTopBar({ position })}>
      <ProgressBar progress={progress} />
      <div className="mx-xxs">
        <IconButton
          intent="ghost"
          size="large"
          aria-label="Back button"
          disabled={backButtonDisabled}
          onClick={onBackButtonClick}
        >
          <span className="sr-only">Back button</span>
          <Icon name="arrow_back" />
        </IconButton>
      </div>
    </div>
  );
};
